import React, {Component} from 'react';
import Card from '../../common/card-grid/Card';
import {
  Button,
  Wrapper,
  Container,
  List,
  Row,
  Item,
  Input,
  selectAll,
  selectNone,
  select,
  isSelected,
  getFilteredData,
} from '../Select';
import {FILTER_NONE, FILTER_ALL} from '../../../constants/filters';
import gql from 'graphql-tag';
import {Query, withApollo} from 'react-apollo';
import SHIFTS from '../../../constants/shifts';
import Loading from '../Loading';
import Error from '../Error';

const shiftsSettingsQuery = gql`
  query shiftsSettings($input: SettingsQueryInput!) {
    shifts {
      id
      name
    }
    settings(input: $input) {
      id
      shifts {
        type
        ids
      }
    }
  }
`;

class ShiftsFilter extends Component {
  state = {
    search: '',
  };

  render() {
    const input = {favoriteId: this.props.favoriteId};
    return (
      <Query query={shiftsSettingsQuery} variables={{input}}>
        {({loading, error, data}) => {
          if (loading)
            return (
              <Card>
                <Loading />
              </Card>
            );
          if (error) return <Error>{error.message}</Error>;
          let filterShifts = getFilteredData(data.shifts, this.state.search);
          const disabled = !data.shifts || data.shifts.length === 0;
          return (
            <Card>
              <Wrapper>
                <Button
                  disabled={disabled}
                  active={data.settings.shifts.type === FILTER_ALL}
                  onClick={() => {
                    if (disabled) return;
                    selectAll(this, data.shifts, 'id', 'shifts');
                  }}>
                  {SHIFTS.find((t) => t.key === FILTER_ALL).label}
                </Button>
                <Button
                  disabled={disabled}
                  active={data.settings.shifts.type === FILTER_NONE}
                  onClick={() => {
                    if (disabled) return;
                    selectNone(this, data.shifts, 'id', 'shifts');
                  }}>
                  {SHIFTS.find((t) => t.key === FILTER_NONE).label}
                </Button>
              </Wrapper>
              <Input
                placeholder={'Search shifts'}
                value={this.state.shifts}
                onChange={(e) => this.setState({search: e.target.value})}
              />
              <Container>
                <List
                  itemCount={filterShifts.length}
                  renderItem={({index, style}) => (
                    <Row
                      style={style}
                      key={index}
                      onClick={() => {
                        if (disabled) return;
                        select(this, data.settings.shifts, filterShifts[index].id, data.shifts, 'id', 'shifts');
                      }}
                      selected={isSelected(data.settings.shifts, filterShifts[index].id)}>
                      <Item>{filterShifts[index].name}</Item>
                    </Row>
                  )}
                />
              </Container>
            </Card>
          );
        }}
      </Query>
    );
  }
}

export default withApollo(ShiftsFilter);
